'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Storage = function () {
  function Storage(storage) {
    _classCallCheck(this, Storage);

    if (storage === false) {
      this.storageEnabled = false;
    } else {
      this.localStorage = storage;
      this.storageEnabled = null;
    }
  }

  _createClass(Storage, [{
    key: 'isStorageEnabled',
    value: function isStorageEnabled() {
      if (this.storageEnabled !== null) {
        return this.storageEnabled;
      }

      try {
        var testKey = 'firealarm-test';
        var time = Date.now();
        this.localStorage.setItem(testKey, time);
        this.storageEnabled = this.localStorage.getItem(testKey) == time;
        this.localStorage.removeItem(testKey);
      } catch (e) {
        this.storageEnabled = false;
      }

      return this.storageEnabled;
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      if (this.isStorageEnabled()) {
        return this.localStorage.getItem(key);
      }

      return null;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      if (this.isStorageEnabled()) {
        this.localStorage.removeItem(key);
      }
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      if (this.isStorageEnabled()) {
        this.localStorage.setItem(key, value);
      }
    }
  }]);

  return Storage;
}();

;

exports.default = Storage;
module.exports = exports['default'];